module.exports = __webpack_public_path__ + "img/navbar_hoverMenu_2_1.3a0b8267.png";